import asyncDispatcher from 'utils/asyncDispatcher';
import { signOut } from 'actions/sign-out';
import {
  XERO_ORGANISATION_FETCH_REQUESTED,
  XERO_ORGANISATION_FETCHED,
  XERO_ORGANISATION_FETCH_FAILED,
} from 'utils/constants';

export const fetchOrganisation = () => (dispatch, getState) => {
  const { api } = getState().app;

  // todo: handle token expiration
  return asyncDispatcher(dispatch, {
    action: api.fetchXeroOrganisation(),
    data: {},
    pending: XERO_ORGANISATION_FETCH_REQUESTED,
    success: XERO_ORGANISATION_FETCHED,
    failure: XERO_ORGANISATION_FETCH_FAILED
  }).catch((error) => {
    if (error.message == 401) {
      const signoutEndpoint = getState().auth.getIn(['configure', 'currentEndpointKey']);
      dispatch(signOut(signoutEndpoint));
    }
  });
}



// WEBPACK FOOTER //
// ./src/actions/xero.js